import React, { useEffect } from "react";
import GetInTouchFooter from "./GetInTouchFooter";
import Footer from "./Footer";
import CustomBlogContainer from "./custom/CustomBlogContainer";

const BlogsAndNews = ({ type }) => {
  useEffect(() => {
    window.scrollTo(0, 20);
  }, []);

  return (
    <>
      <CustomBlogContainer type={type} paddingX={"6%"} />
      <GetInTouchFooter marginX={"6%"} />
      <Footer marginX={"6%"} />
    </>
  );
};

export default BlogsAndNews;
